import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FacebookMessengerIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0531 14.413L10.4671 11.754L5.48603 14.48L10.9469 8.744L13.5329 11.403L18.514 8.677L13.0531 14.413ZM12.0005 2C6.47699 2 2 6.144 2 11.257C2 14.165 3.44957 16.76 5.71534 18.457V22L9.12763 20.126C10.0378 20.378 11.0015 20.514 12.0005 20.514C17.523 20.514 22 16.369 22 11.257C22 6.144 17.523 2 12.0005 2Z",
    fill: "currentColor"
  }));
}